import { render, staticRenderFns } from "./LowModule.vue?vue&type=template&id=22d3db93"
import script from "./LowModule.vue?vue&type=script&lang=js"
export * from "./LowModule.vue?vue&type=script&lang=js"
import style0 from "./LowModule.vue?vue&type=style&index=0&id=22d3db93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports